import { useSignInUpAfterCartExperiment } from 'experiments/use-sign-in-up-after-cart-experiment';
import { useAuthContext } from 'state/auth';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

const useIsSignUpAfterCartEnabled = (): boolean => {
  const { isAuthenticated } = useAuthContext();
  const isMoveSignupAfterCartEnabled = useFlag(LaunchDarklyFlag.ENABLE_MOVE_SIGNUP_AFTER_CART);
  const isSignInUpAfterCartExperimentEnabled = useSignInUpAfterCartExperiment();

  return !isAuthenticated && (isMoveSignupAfterCartEnabled || isSignInUpAfterCartExperimentEnabled);
};

export default useIsSignUpAfterCartEnabled;
